import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';

import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { LocationSubset } from '@era/stores';
import { ModelNamesFilter } from './model-names-filter';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-reboot-devices-modal-ui',
  templateUrl: './reboot-devices-modal.component.html',
  styleUrls: ['./reboot-devices-modal.component.scss'],
  imports: [ReactiveFormsModule],
})
export class RebootDevicesModalComponent {
  @Input() public locationSubset: LocationSubset;
  @Output() public readonly submitFilters = new EventEmitter<ModelNamesFilter>();
  @Output() public readonly closeModal = new EventEmitter<void>();
  public readonly rebootDevicesForm: UntypedFormGroup;
  private readonly modelNamesFilter = new ModelNamesFilter();
  modelChecked = false;

  LocationSubset = LocationSubset;

  constructor(private readonly formBuilder: UntypedFormBuilder) {
    this.rebootDevicesForm = this.formBuilder.group(this.modelNamesFilter);
    this.rebootDevicesForm.setValidators(this.validateCheckboxes());
  }

  validateCheckboxes() {
    return (formGroup: UntypedFormGroup) => {
      let checked = 0;

      Object.keys(formGroup.controls).forEach((key) => {
        const control = formGroup.controls[key];
        if (control.value) {
          checked += 1;
        }
      });

      if (checked === 0) {
        return { requireOneDeviceModelChecked: true };
      }

      return null;
    };
  }

  closingModal() {
    this.closeModal.emit();
  }

  onSubmit() {
    this.modelNamesFilter.AppleTV = this.rebootDevicesForm.get('AppleTV').value;
    this.modelNamesFilter.iPad = this.rebootDevicesForm.get('iPad').value;
    this.modelNamesFilter.iPhone = this.rebootDevicesForm.get('iPhone').value;
    this.modelNamesFilter.iPod = this.rebootDevicesForm.get('iPod').value;

    this.submitFilters.emit(this.modelNamesFilter);

    this.rebootDevicesForm.reset();
    this.closingModal();
  }
}
